import { Button, Grid } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import WorkQueues from 'enums/workQueue.enum';
import { filterOrders, listOrdersByPage } from 'store/thunks/workQueueThunks';

import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import OrderVerificationFilterButton from './OrderVerificationFilterButton';
import OrderVerificationStatusBar from './OrderVerificationFilterStatusBar';
import OrderVerificationOuterFilter from './OrderVerificationOuterFilter';
import OrderVerificationTable from './OrderVerificationTable';

const URGENT_TAG = 'URGENT';

const OrderVerification = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { filter, currentPage } = useSelector(
    ({ workQueue }) => workQueue.orderVerification,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.ORDER_VERIFICATION)) {
      dispatch(listOrdersByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  const isUrgentFilterActive = filter?.tags?.includes(URGENT_TAG);

  const handleUrgentFilter = useCallback(() => {
    const currentTags = filter?.tags || [];
    const newTags = isUrgentFilterActive
      ? currentTags.filter((t) => t !== URGENT_TAG)
      : [...currentTags, URGENT_TAG];
    dispatch(
      filterOrders({
        filter: {
          ...filter,
          tags: newTags.length > 0 ? newTags : undefined,
          // POM-6330: the Urgent view is always Exact, even if Tags had been switched to Contains.
          tagMatchMode: undefined,
        },
      })
    );
  }, [dispatch, filter, isUrgentFilterActive]);

  if (preset !== WorkQueues.ORDER_VERIFICATION) return null;

  return (
    <Grid container sx={{ py: 3 }} justifyContent='space-between' alignItems='center'>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }}>
        <OrderVerificationStatusBar />
      </Grid>
      <Grid item>
        <Grid container gap={2} alignItems='center'>
          <Button
            variant={isUrgentFilterActive ? 'contained' : 'outlined'}
            color='info'
            onClick={handleUrgentFilter}
            sx={{ height: 33 }}
          >
            Urgent
          </Button>
          <OrderVerificationOuterFilter />
          <Grid item>
            <OrderVerificationFilterButton />
          </Grid>
        </Grid>
      </Grid>
      <OrderVerificationTable />
    </Grid>
  );
};

export default OrderVerification;
